module.exports = __webpack_public_path__ + "static/media/SuccessPath.5591e093.svg";